module.exports = __webpack_public_path__ + "components/flag/static/square/ru-3f0a8ed7f381aa8d9114dcb62b12bda9.svg";